import styled from 'styled-components';

export const ActivityLogListContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  
  h3 {
    margin: 0;
    color: #333;
    font-size: 18px;
    font-weight: 600;
  }
`;

export const ActivityLogDisplay = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const NoDataMessage = styled.div`
  text-align: center;
  color: #666;
  font-style: italic;
  padding: 20px;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 6px;
  border: 1px solid rgba(255, 255, 255, 0.2);
`;
